var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 9.92153C11.125 10.095 11.0616 10.2451 10.9348 10.3719L6.45044 14.8554C6.32365 14.9821 6.1735 15.0455 6 15.0455C5.8265 15.0455 5.67635 14.9821 5.54956 14.8554L1.06519 10.3719C0.938395 10.2451 0.875 10.095 0.875 9.92153C0.875 9.74806 0.938395 9.59795 1.06519 9.47118C1.19198 9.34442 1.34212 9.28104 1.51562 9.28104H10.4844C10.6579 9.28104 10.808 9.34442 10.9348 9.47118C11.0616 9.59795 11.125 9.74806 11.125 9.92153ZM11.125 6.07856C11.125 6.25202 11.0616 6.40214 10.9348 6.52891C10.808 6.65567 10.6579 6.71905 10.4844 6.71905H1.51562C1.34212 6.71905 1.19198 6.65567 1.06519 6.52891C0.938395 6.40214 0.875 6.25202 0.875 6.07856C0.875 5.90509 0.938395 5.75497 1.06519 5.62821L5.54956 1.14474C5.67635 1.01797 5.8265 0.95459 6 0.95459C6.1735 0.95459 6.32365 1.01797 6.45044 1.14474L10.9348 5.62821C11.0616 5.75497 11.125 5.90509 11.125 6.07856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.91a23120f4a2efef629be54c0d3f0c11.svg";
export { ForwardRef as ReactComponent };